const fromPairs = <TKey extends string = string, TValue = any>(arr: [TKey, TValue][]) => arr.reduce<Record<TKey, TValue>>((acc, val) => (acc[val[0]] = val[1], acc), {} as Record<TKey, TValue>);

export default fromPairs;
